import React, { useState, useEffect } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { ShelterOccupancyPercentageMetric } from "./charts-metrics/ShelterOccupancyPercentageMetric";
import { ShelterIntake7DayMetric } from "./charts-metrics/ShelterIntake7DayMetric";
import { ShelterExit7DayMetric } from "./charts-metrics/ShelterExit7DayMetric";
import { ShelterVacancyMetric } from "./charts-metrics/ShelterVacancyMetric";
import { ShelterOccupancyLineChart } from "./charts-metrics/ShelterOccupancyLineChart";
import { ShelterInfractionsBarChart } from "./charts-metrics/ShelterInfractionsBarChart";
import { ShelterOccupiedMetric } from "./charts-metrics/ShelterOccupiedMetric";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import { fetchReportShelterIntakesExits, fetchReportShelterOccupancy } from "../../services/httpClient";
import DataTable from "./ui/DataTable";
import { ShelterExit7DayTypeMetric } from "./charts-metrics/ShelterExit7DayTypeMetric";

const ShelterTab = ({ buildPDF, canvas, setCanvas, iPad }: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [reportRunning, setReportRunning] = useState<boolean>(false);
  const [occupancyData, setOccupancyData] = useState<any[] | null>(null);
  const [intakeData, setIntakeData] = useState<any[] | null>(null);
  const [selectedData, setSelectedData] = useState<any[] | null>(null);
  const [activeIntake, setActiveIntake] = useState<boolean>(false);
  const [activeExit, setActiveExit] = useState<boolean>(false);
  const [activeExitInv, setActiveExitInv] = useState<boolean>(false);
  const [activeExitVol, setActiveExitVol] = useState<boolean>(false);
  const [activeExitBan, setActiveExitBan] = useState<boolean>(false);

  const intakeExitHeaders = [
    { label: "Name", key: "name" },
    { label: "Intake At", key: "intake_at" },
    { label: "Exit At", key: "exit_at" },
    { label: "Exit Type", key: "exit_type" },
  ];

  useEffect(() => {
    getOccupancyData();
    getIntakeExitData();
  }, []);

  useEffect(() => {
    if (activeIntake) {
      setActiveExit(false);
      setActiveExitInv(false);
      setActiveExitVol(false);
      setActiveExitBan(false);
    }
  }, [activeIntake]);

  useEffect(() => {
    if (activeExit) {
      setActiveIntake(false);
      setActiveExitInv(false);
      setActiveExitVol(false);
      setActiveExitBan(false);
    }
  }, [activeExit]);

  useEffect(() => {
    if (activeExitInv) {
      setActiveIntake(false);
      setActiveExit(false);
      setActiveExitVol(false);
      setActiveExitBan(false);
    }
  }, [activeExitInv]);

  useEffect(() => {
    if (activeExitVol) {
      setActiveIntake(false);
      setActiveExit(false);
      setActiveExitInv(false);
      setActiveExitBan(false);
    }
  }, [activeExitVol]);

  useEffect(() => {
    if (activeExitBan) {
      setActiveIntake(false);
      setActiveExit(false);
      setActiveExitInv(false);
      setActiveExitVol(false);
    }
  }, [activeExitBan]);

  const getOccupancyData = () => {
    fetchReportShelterOccupancy()
      .then((res: any) => {
        setOccupancyData(res[0].data);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getIntakeExitData = () => {
    fetchReportShelterIntakesExits()
      .then((res: any) => {
        setIntakeData(res[0].data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (reportRunning) {
      buildPDF();
      setReportRunning(false);
    }
  }, [canvas]);

  const downloadReport = async () => {
    setReportRunning(true);
    const reportSection = document.getElementById("shelter-section");
    const reportTitle = document.getElementById("shelter-title");

    if (reportSection) {
      if (reportTitle) {
        reportTitle.style.visibility = "hidden";
        reportTitle.style.display = "none";
      }

      const images = reportSection.getElementsByTagName("img");
      for (let i = 0; i < images.length; i++) {
        images[i].crossOrigin = "anonymous";
      }

      const canvas = await html2canvas(reportSection, { useCORS: true });
      setCanvas(canvas);

      if (reportTitle) {
        reportTitle.style.visibility = "visible";
        reportTitle.style.display = "flex";
      }
    } else {
      console.error("Report section not found");
      setReportRunning(false);
    }
  };

  return (
    <div id="shelter-section">
      {isLoading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" style={{ color: "#F6893D" }} />
        </div>
      ) : (
        <>
          <Row id="shelter-title" className="mb-3">
            <Col className="col-8">
              <h4 className="hero-heading app-header-text">Shelter</h4>
            </Col>
            <Col className="text-end col-4">
              {!iPad && (
                <Button className="app-primary-color button" onClick={() => downloadReport()}>
                  <FontAwesomeIcon icon={faDownload} />
                  {" Report"}
                </Button>
              )}
            </Col>
          </Row>
          {occupancyData && (
            <Row className="mb-3">
              <Col xs={12}>
                <Row>
                  <Col xs={3} className="mb-3">
                    <ShelterVacancyMetric data={occupancyData} />
                  </Col>
                  <Col xs={3} className="mb-3">
                    <ShelterOccupiedMetric data={occupancyData} />
                  </Col>
                  <Col xs={3} className="mb-3">
                    <ShelterOccupancyPercentageMetric data={occupancyData} />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {intakeData && (
            <Row id="occupancy-line" className="mb-5">
              <Col className="col-10">
                <ShelterOccupancyLineChart data={intakeData} />
              </Col>
            </Row>
          )}
          {intakeData && (
            <Row>
              <Col xs={12} className="mb-3">
                <Row>
                  <Col xs={2} className="mb-3">
                    <ShelterIntake7DayMetric
                      data={intakeData}
                      setSelectedData={setSelectedData}
                      active={activeIntake}
                      setActive={setActiveIntake}
                    />
                  </Col>
                  <Col xs={2} className="mb-3">
                    <ShelterExit7DayMetric data={intakeData} setSelectedData={setSelectedData} active={activeExit} setActive={setActiveExit} />
                  </Col>
                  <Col xs={2} className="mb-3">
                    <ShelterExit7DayTypeMetric
                      data={intakeData}
                      setSelectedData={setSelectedData}
                      active={activeExitInv}
                      setActive={setActiveExitInv}
                      exitType="involuntary"
                    />
                  </Col>
                  <Col xs={2} className="mb-3">
                    <ShelterExit7DayTypeMetric
                      data={intakeData}
                      setSelectedData={setSelectedData}
                      active={activeExitVol}
                      setActive={setActiveExitVol}
                      exitType="voluntary"
                    />
                  </Col>
                  <Col xs={2} className="mb-3">
                    <ShelterExit7DayTypeMetric
                      data={intakeData}
                      setSelectedData={setSelectedData}
                      active={activeExitBan}
                      setActive={setActiveExitBan}
                      exitType="ban"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {selectedData && <DataTable tableHeadings={intakeExitHeaders} tableData={selectedData} />}
          <Row id="infractions-bar" className="mb-5">
            <Col className="col-10">
              <ShelterInfractionsBarChart />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default ShelterTab;
